<template>
  <div class="table-container">
    <vab-query-form>
      <vab-query-form-left-panel>
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <el-form-item label="品牌名">
            <el-input v-model="queryForm.name" placeholder="请输入品牌名" />
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>

      <vab-query-form-right-panel>
        <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
          添加
        </el-button>
        <!--        <el-button icon="el-icon-delete" type="danger" @click="handleDelete">
          删除
        </el-button> -->
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      :height="height" border @selection-change="setSelectRows" @sort-change="tableSortChange">
      <!-- 编码 -->
      <el-table-column show-overflow-tooltip prop="sort" label="序号" sortable width="150"
        align="center"></el-table-column>

      <el-table-column show-overflow-tooltip prop="name" label="品牌名" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="country_name" label="线路" align="center">
      </el-table-column>

      <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" width="340" sortable
        align="center"></el-table-column>
      <el-table-column show-overflow-tooltip label="操作面板" width="250px" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" @click="see_type(row)">品牌分类</el-button>
          <el-button type="text" style="margin-left: 25px; color: #ff0000" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    <manage-brand ref="edit" @fetch-data="getnewlist"></manage-brand>
  </div>
</template>

<script>
  import {
    brandList,
    brandDel,
    Index_country_list
  } from '@/api/xgcApi'
  import manageBrand from '../components/manageBrand'
  export default {
    name: 'ComprehensiveTable',
    components: {
      manageBrand,
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger',
        }
        return statusMap[status]
      },
    },
    data() {
      return {
        options:[

        ],
        height: '74vh',
        imgShow: true,
        list: [],
        imageList: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        background: true,
        selectRows: '',
        elementLoadingText: '正在加载...',
        queryForm: {
          page: 1,
          limit: 50,
          name: '',
          kor_type:4
        },
        value1: '',
        value: '',
      }
    },
    // computed: {
    //   height() {
    //     return this.$baseTableHeight()
    //   },
    // },
    created() {
      this.fetchData()
      this.getBrand()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
      see_type(e){
         this.$router.push({path: "/regulate/manageTypes", query: {id: e.id}})
      },
      getBrand(){
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
        })
      },
      getnewlist() {
        this.fetchData()
      },
      tableSortChange() {
        const imageList = []
        this.$refs.tableSort.tableData.forEach((item, index) => {
          imageList.push(item.img)
        })
        this.imageList = imageList
      },
      setSelectRows(val) {
        this.selectRows = val
      },
      handleAdd() {
        this.$refs['edit'].showEdit()
      },
      handleEdit(row) {
        this.$refs['edit'].showEdit(row)
      },
      handleDelete(row) {
        if (row.id) {
          this.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const {
              msg
            } = await brandDel({
              ids: row.id
            })
            this.$baseMessage(msg, 'success')
            this.fetchData()
          })
        } else {
          if (this.selectRows.length > 0) {
            const ids = this.selectRows.map((item) => item.id).join()
            this.$baseConfirm('你确定要删除选中项吗', null, async () => {
              const {
                msg
              } = await brandDel({
                ids: ids
              })
              this.$baseMessage(msg, 'success')
              this.fetchData()
            })
          } else {
            this.$baseMessage('未选中任何行', 'error')
            return false
          }
        }
      },
      handleSizeChange(val) {
        this.queryForm.limit = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      handleQuery() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const {
          data
        } = await brandList(this.queryForm)
        this.list = data.list
        this.total = data.count
        setTimeout(() => {
          this.listLoading = false
        }, 500)
      },
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }
</style>
